import { useEffect, useState } from "react";
import Logo from "./logo";
import client from "../../client/Client";

export default function Footer() {
  const [YearVersion, setYearVersion] = useState("");
  
  useEffect(() => {
    client.fetch('*[_type == "YearVersion"]')
      .then((result) => {
        if(result.length > 0) {
          setYearVersion(result[0].YearVersion);
        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }, []);
  
  return (
    <footer className="bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        {/* Top area: Blocks */}
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-12 gap-6 py-6 md:py-8 lg:py-12 border-t border-gray-200">
          
          {/* 1st block - First column on mobile */}
          {/* 1st block - First column on mobile */}
          <div className="col-span-1 lg:col-span-3 text-center lg:text-left">
            <div className="mb-4 sm:mb-2 flex justify-center lg:block">
              <Logo />
            </div>
            <div className="text-sm text-gray-600 flex flex-wrap justify-center lg:justify-start gap-1 sm:gap-0">
              <a
                href="#0"
                className="text-gray-600 hover:text-gray-900 hover:underline transition duration-150 ease-in-out"
              >
                Terms
              </a>
              <span className="hidden sm:inline"> · </span>
              <a
                href="#0"
                className="text-gray-600 hover:text-gray-900 hover:underline transition duration-150 ease-in-out"
              >
                Privacy Policy
              </a>
            </div>
          </div>

          {/* 2nd block - Second column on mobile */}
          <div className="col-span-1 lg:col-span-2 text-center sm:text-left">
            <h6 className="text-gray-800 font-medium mb-3 sm:mb-2">Conferences</h6>
            <ul className="text-sm space-y-2 sm:space-y-1">
              {['SAC', 'PSE', 'SCI', 'CSP'].map((conf) => (
                <li key={conf}>
                  <a
                    href={`/${conf.toLowerCase()}`}
                    className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out block py-1 sm:py-0"
                  >
                    {conf}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 3rd block - First column of second row on mobile */}
          <div className="col-span-1 lg:col-span-2 text-center sm:text-left">
            <h6 className="text-gray-800 font-medium mb-3 sm:mb-2">Committees</h6>
            <ul className="text-sm space-y-2 sm:space-y-1">
              {[
                { name: "Chairs", path: "/chairs" },
                { name: "Steering Committees", path: "/steering-committee" },
                { name: "Scientific Committees", path: "/scientific-committee" },
                { name: "Organizing Committee", path: "/organizing-committee" },
                { name: "Ambassadors", path: "/ambassadors" },
                { name: "Sponsors", path: "/sponsors" },
                { name: "Organizers", path: "/organizers" }
              ].map((item) => (
                <li key={item.path}>
                  <a
                    href={item.path}
                    className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out block py-1 sm:py-0"
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 4th block - Second column of second row on mobile */}
          <div className="col-span-1 lg:col-span-2 text-center sm:text-left">
            <h6 className="text-gray-800 font-medium mb-3 sm:mb-2">Programs</h6>
            <ul className="text-sm space-y-2 sm:space-y-1">
              {[
                { name: "Technical Program", path: `/technical-program/${YearVersion}` },
                { name: "Speakers", path: "/Speakers" },
                { name: "Special Sessions", path: "/special-sessions" },
                { name: "Call For Special Sessions", path: "/call-for-special-sessions" },
                { name: "Phd Student Contest", path: "/phd-student-contest" },
                { name: "Workshop and Tutorial Sessions", path: "/workshop-and-tutorial-sessions" },
                { name: "Workshops", path: "/workshops" },
                { name: "Social Program", path: "/social-program" },
                { name: "Awards", path: "/awards" }
              ].map((item) => (
                <li key={item.path}>
                  <a
                    href={item.path}
                    className="text-gray-600 hover:text-gray-900 transition duration-150 ease-in-out block py-1 sm:py-0"
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 5th block - Full width on mobile, spans both columns */}
          <div className="col-span-2 lg:col-span-3 text-center sm:text-left">
            <h6 className="text-gray-800 font-medium mb-3 sm:mb-2">Subscribe</h6>
            <p className="text-sm text-gray-600 mb-4">
              Get the latest news and articles to your inbox every month.
            </p>
            <form>
              <div className="flex flex-col sm:flex-row gap-2 max-w-xs mx-auto sm:mx-0">
                <div className="flex-1">
                  <label className="block text-sm sr-only" htmlFor="newsletter">
                    Email
                  </label>
                  <div className="relative">
                    <input
                      id="newsletter"
                      type="email"
                      className="form-input w-full text-gray-800 px-3 py-2 pr-12 text-sm border border-gray-300 rounded-lg"
                      placeholder="Your email"
                      required
                    />
                    <button
                      type="submit"
                      className="absolute inset-y-0 right-0 px-3 flex items-center"
                      aria-label="Subscribe"
                    >
                      <svg
                        className="w-4 h-4 fill-current text-blue-600 shrink-0"
                        viewBox="0 0 12 12"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.707 5.293L7 .586 5.586 2l3 3H0v2h8.586l-3 3L7 11.414l4.707-4.707a1 1 0 000-1.414z"
                          fillRule="nonzero"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* Bottom area */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between py-4 md:py-8 border-t border-gray-200 space-y-4 md:space-y-0">
          
          {/* Copyright - Comes first on mobile */}
          <div className="text-sm text-gray-600 text-center md:text-left order-2 md:order-1">
            &copy; 2027 SSD - The International Multi-Conference on Systems,
            Signals and Devices
          </div>

          {/* Social links */}
          <ul className="flex justify-center space-x-4 order-1 md:order-2">
            <li>
              <a
                href="https://twitter.com/ssd_conference"
                className="flex justify-center items-center text-gray-600 hover:text-gray-900 bg-white hover:bg-gray-50 rounded-full shadow transition duration-150 ease-in-out w-10 h-10"
                aria-label="Twitter"
              >
                <svg
                  className="w-8 h-8 fill-current"
                  viewBox="0 0 32 32"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M24 11.5c-.6.3-1.2.4-1.9.5.7-.4 1.2-1 1.4-1.8-.6.4-1.3.6-2.1.8-.6-.6-1.5-1-2.4-1-1.7 0-3.2 1.5-3.2 3.3 0 .3 0 .5.1.7-2.7-.1-5.2-1.4-6.8-3.4-.3.5-.4 1-.4 1.7 0 1.1.6 2.1 1.5 2.7-.5 0-1-.2-1.5-.4 0 1.6 1.1 2.9 2.6 3.2-.3.1-.6.1-.9.1-.2 0-.4 0-.6-.1.4 1.3 1.6 2.3 3.1 2.3-1.1.9-2.5 1.4-4.1 1.4H8c1.5.9 3.2 1.5 5 1.5 6 0 9.3-5 9.3-9.3v-.4c.7-.5 1.3-1.1 1.7-1.8z" />
                </svg>
              </a>
            </li>
            
            <li>
              <a
                href="https://www.facebook.com/people/International-Multi-Conference-on-Systems-Signals-Devices-SSD/100064327764371/"
                className="flex justify-center items-center text-gray-600 hover:text-gray-900 bg-white hover:bg-gray-50 rounded-full shadow transition duration-150 ease-in-out w-10 h-10"
                aria-label="Facebook"
              >
                <svg
                  className="w-8 h-8 fill-current"
                  viewBox="0 0 32 32"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M14.023 24L14 17h-3v-3h3v-2c0-2.7 1.672-4 4.08-4 1.153 0 2.144.086 2.433.124v2.821h-1.67c-1.31 0-1.563.623-1.563 1.536V14H21l-1 3h-2.72v7h-3.257z" />
                </svg>
              </a>
            </li>
                {/* LinkedIn */}
            <li >
              <a
                href="https://www.linkedin.com/company/ssd-conference/"
                className="flex justify-center items-center text-gray-600 hover:text-gray-900 bg-white hover:bg-gray-50 rounded-full shadow transition duration-150 ease-in-out w-10 h-10"
                aria-label="LinkedIn"
              >
                <svg
                  className="w-6 h-6 fill-current"
                  viewBox="0 0 32 32"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M10.1 27H5.6V12.3h4.5V27zM7.9 10.5c-1.4 0-2.4-1.1-2.4-2.5S6.4 5.5 7.9 5.5s2.4 1.1 2.4 2.5c0 1.3-1 2.5-2.4 2.5zM27 27h-4.5v-7.2c0-1.7-.6-2.8-2-2.8-1.1 0-1.7.7-2 1.4-.1.2-.1.5-.1.8V27h-4.5s.1-12.4 0-13.7h4.5v1.9c.6-.9 1.7-2.1 4-2.1 2.9 0 5.1 1.9 5.1 6V27z" />
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}